// Formats date string value to dd/mm/yyyy format

import { isValidDate } from './validators/date';

const formatDate = (date: string) => {
  const d = new Date('date');

  if (!isValidDate(d)) { return date; }

  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;
  const year = d.getFullYear();

  if (month.length < 2) { month = `0${month}`; }
  if (day.length < 2) { day = `0${day}`; }

  return [day, month, year].join('/');
};

export default formatDate;
